import {getCustomDataString, transferCustomDataFields} from '../utils/Utils';

export interface CustomDataValues {
  customData1?: string;
  customData2?: string;
  customData3?: string;
  customData4?: string;
  customData5?: string;
  customData6?: string;
  customData7?: string;
  customData8?: string;
  customData9?: string;
  customData10?: string;
  customData11?: string;
  customData12?: string;
  customData13?: string;
  customData14?: string;
  customData15?: string;
  customData16?: string;
  customData17?: string;
  customData18?: string;
  customData19?: string;
  customData20?: string;
  customData21?: string;
  customData22?: string;
  customData23?: string;
  customData24?: string;
  customData25?: string;
  customData26?: string;
  customData27?: string;
  customData28?: string;
  customData29?: string;
  customData30?: string;
  customData31?: string;
  customData32?: string;
  customData33?: string;
  customData34?: string;
  customData35?: string;
  customData36?: string;
  customData37?: string;
  customData38?: string;
  customData39?: string;
  customData40?: string;
  customData41?: string;
  customData42?: string;
  customData43?: string;
  customData44?: string;
  customData45?: string;
  customData46?: string;
  customData47?: string;
  customData48?: string;
  customData49?: string;
  customData50?: string;
  customData51?: string;
  customData52?: string;
  customData53?: string;
  customData54?: string;
  customData55?: string;
  customData56?: string;
  customData57?: string;
  customData58?: string;
  customData59?: string;
  customData60?: string;
  customData61?: string;
  customData62?: string;
  customData63?: string;
  customData64?: string;
  customData65?: string;
  customData66?: string;
  customData67?: string;
  customData68?: string;
  customData69?: string;
  customData70?: string;
  customData71?: string;
  customData72?: string;
  customData73?: string;
  customData74?: string;
  customData75?: string;
  customData76?: string;
  customData77?: string;
  customData78?: string;
  customData79?: string;
  customData80?: string;
  customData81?: string;
  customData82?: string;
  customData83?: string;
  customData84?: string;
  customData85?: string;
  customData86?: string;
  customData87?: string;
  customData88?: string;
  customData89?: string;
  customData90?: string;
  customData91?: string;
  customData92?: string;
  customData93?: string;
  customData94?: string;
  customData95?: string;
  customData96?: string;
  customData97?: string;
  customData98?: string;
  customData99?: string;
  customData100?: string;
  experimentName?: string;
}

/**
 * Lists all keys of the {@see CustomDataValues} interface.
 */
export const customDataValuesKeys: Array<keyof CustomDataValues> = [
  'customData1',
  'customData2',
  'customData3',
  'customData4',
  'customData5',
  'customData6',
  'customData7',
  'customData8',
  'customData9',
  'customData10',
  'customData11',
  'customData12',
  'customData13',
  'customData14',
  'customData15',
  'customData16',
  'customData17',
  'customData18',
  'customData19',
  'customData20',
  'customData21',
  'customData22',
  'customData23',
  'customData24',
  'customData25',
  'customData26',
  'customData27',
  'customData28',
  'customData29',
  'customData30',
  'customData31',
  'customData32',
  'customData33',
  'customData34',
  'customData35',
  'customData36',
  'customData37',
  'customData38',
  'customData39',
  'customData40',
  'customData41',
  'customData42',
  'customData43',
  'customData44',
  'customData45',
  'customData46',
  'customData47',
  'customData48',
  'customData49',
  'customData50',
  'customData51',
  'customData52',
  'customData53',
  'customData54',
  'customData55',
  'customData56',
  'customData57',
  'customData58',
  'customData59',
  'customData60',
  'customData61',
  'customData62',
  'customData63',
  'customData64',
  'customData65',
  'customData66',
  'customData67',
  'customData68',
  'customData69',
  'customData70',
  'customData71',
  'customData72',
  'customData73',
  'customData74',
  'customData75',
  'customData76',
  'customData77',
  'customData78',
  'customData79',
  'customData80',
  'customData81',
  'customData82',
  'customData83',
  'customData84',
  'customData85',
  'customData86',
  'customData87',
  'customData88',
  'customData89',
  'customData90',
  'customData91',
  'customData92',
  'customData93',
  'customData94',
  'customData95',
  'customData96',
  'customData97',
  'customData98',
  'customData99',
  'customData100',

  'experimentName',
];

/**
 * The number of CustomDataXX fields in {@see CustomDataValues}.
 */
export const customDataFieldCount = customDataValuesKeys.filter((i) => i.match('customData\\d+')).length;

/**
 * We are extracting the customData fields explicitly to make sure that there is not a different object passed
 */
export const extractCustomDataFieldsOnly = (input: CustomDataValues): CustomDataValues => {
  const retVal: CustomDataValues = {};
  customDataValuesKeys.forEach((key) => {
    if (input[key]) {
      retVal[key] = input[key];
    }
  });
  return retVal;
};

export const sanitizeCustomDataValues = (customDataValues: CustomDataValues): CustomDataValues => {
  const extracted = extractCustomDataFieldsOnly(customDataValues);

  const sanitizedCustomDataValues: CustomDataValues = {};
  transferCustomDataFields(extracted, sanitizedCustomDataValues);
  // fix a bug of transferCustomDataFields that does not transfer 'experimentName' field, because it is not named 'customDataXX'
  // should be fixed with https://bitmovin.atlassian.net/browse/AN-5182
  sanitizedCustomDataValues.experimentName = getCustomDataString(extracted.experimentName);

  return sanitizedCustomDataValues;
};
